import { useQuery } from '@tanstack/react-query'
import {
  getLeadById,
  getLeadActivities
} from '../services/leadsService'

export const leadDetailKeys = {
  lead: (leadId, options) => ['lead-detail', leadId, options],
  activities: (leadId, options) => ['lead-detail-activities', leadId, options]
}

/**
 * @param {string | null | undefined} leadId
 * @param {{ role?: string, userId?: string }} auth
 * @param {{ enabled?: boolean }} [config]
 */
export const useLeadDetail = (leadId, auth = {}, config = {}) => {
  const { role, userId } = auth
  const options = { role, userId }
  const enabled = Boolean(leadId && userId) && (config.enabled ?? true)

  return useQuery({
    queryKey: leadDetailKeys.lead(leadId, options),
    queryFn: async () => {
      const { data, error } = await getLeadById(leadId, options)
      if (error) throw error
      if (!data) throw new Error('Lead not found.')
      return data
    },
    enabled,
    staleTime: config.staleTime ?? 1000 * 60 * 2
  })
}

/**
 * @param {string | null | undefined} leadId
 * @param {{ role?: string, userId?: string }} auth
 * @param {{ enabled?: boolean }} [config]
 */
export const useLeadMeetingActivities = (leadId, auth = {}, config = {}) => {
  const { role, userId } = auth
  const options = { role, userId }
  const enabled = Boolean(leadId && userId) && (config.enabled ?? true)

  return useQuery({
    queryKey: leadDetailKeys.activities(leadId, options),
    queryFn: async () => {
      const { data, error } = await getLeadActivities(leadId, options)
      if (error) throw error
      return data ?? []
    },
    enabled,
    staleTime: config.staleTime ?? 1000 * 60 * 2
  })
}
